module.exports = __webpack_public_path__ + "static/media/IncreaseImpact.b915efc8.svg";